import { COMPANY_FILTER_CHANGE } from '../../../PartnerOptions/constants'

import { DATA_REQUEST_ASYNC } from './constants'

export default function () {
  const initialState = {
    data: [],
    loader: false,
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case DATA_REQUEST_ASYNC.INITIATE:
      case COMPANY_FILTER_CHANGE:
        return { ...state, loader: true }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          error: null,
          loader: false,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      case DATA_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      default:
        return state
    }
  }
}
